import { CaretDownFilledIcon, CaretUpFilledIcon } from "@/assets/images/svgIcons/caretIcon"
import { Text, type TextProps } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"

type VariationBadgeProps = {
  value: number
  direction: "up" | "down" | "neutral"
  type: "percent" | "points"
  size?: string
  className?: string
  fontStyle?: TextProps["fontStyle"]
}

export function VariationBadge({
  value,
  direction,
  type,
  size = "size-5",
  className,
  fontStyle = "LS",
}: VariationBadgeProps) {
  const isPositive = direction === "up"
  const isNegative = direction === "down"

  if (value === 0 || direction === "neutral") return null

  return (
    <div className="flex items-center gap-0.5">
      {isPositive && (
        <CaretUpFilledIcon
          className={cn("-mx-1 text-feedback-positive-intense", size)}
          color="currentColor"
          fill="currentColor"
        />
      )}
      {isNegative && (
        <CaretDownFilledIcon
          className={cn("-mx-1 text-feedback-negative-intense", size)}
          color="currentColor"
          fill="currentColor"
        />
      )}
      <Text
        fontStyle={fontStyle}
        className={cn(
          "text-textOnSurface-subtle",
          className,
          isPositive ? "text-feedback-positive-intense" : "text-feedback-negative-intense",
        )}
      >
        {isPositive ? "+" : "-"}
        {Math.abs(value)}
        {type === "percent" && "%"}
      </Text>
    </div>
  )
}
